import { lazy } from 'react';

import Loadable from '../components/Loadable';
import MinimalLayout from '../layout/MinimalLayout';

const LoginPage = Loadable(lazy(() => import('../pages/Auth/Login')));

const MainRoutes = {
    path: 'login/',
    element: <MinimalLayout />,
    children: [
        {
            path: '', element: <LoginPage />
        }
    ]
};

export default MainRoutes;